<script>
import { Cell, Calendar } from 'vant'
import DateTimeFunc from '@/tbs/util/DateTimeFunc'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'calendar-selector',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-calendar': Calendar
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label:String,
        value:Date,
        dateFormat:String,
        disabled: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
    emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: false,
            selectedValue: null,
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        dateLabel() {
            let selectedLabel = ''
            const format = this.dateFormat || 'yyyy-MM-dd'
            if (this.selectedValue) {
                selectedLabel = DateTimeFunc.formatDate(this.selectedValue, format)
            }
            else if (this.value) {
                selectedLabel = DateTimeFunc.formatDate(this.value, format)
            }
            return selectedLabel
        },
        minDate() {
            const today = new Date
            const oneYear = 12 * 30 * 24 * 60 * 60 * 1000
            return new Date(today.getTime() - oneYear)
        },
        defaultDate() {
            return this.value ? this.value : (new Date)
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onCalendarConfirm(data) {
            console.log('onCalendarConfirm', data)
            this.selectedValue = data
            this.showPopup = false
            this.$emit('change-data', data)
        },
        onCalendarLinkClick() {
            if (!this.disabled) {
                this.showPopup = true
            }
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="calendar-selector van-cell no-padding">
        <van-cell
            :class="{ disabled: disabled }"
            :title="label"
            :value="dateLabel"
            :is-link="!disabled"
            @click="onCalendarLinkClick"
        />
        <van-calendar
            v-model="showPopup"
            :show-confirm="false"
            :default-date="defaultDate"
            :min-date="minDate"
            color="#4AA2F7"
            @confirm="onCalendarConfirm"
        />
    </div>
</template>